/*@flow*/
import { useEffect } from 'react';
import useAutocomplete from 'lib/useAutocomplete';
import useStoreState from 'lib/useStoreState';
import Blank from 'lib/Blank';
import useCommands from 'comps/Left2/useCommands';

export default function useBboxBoundAutoComplete(ref: {|
  current: null | any,
|}) {
  const { bbox } = useStoreState({ bbox: '$query.filter.bbox' });
  const { googPlace, apiRef } = useAutocomplete(ref);
  const cmd = useCommands();

  useEffect(() => {
    bbox && apiRef.current && apiRef.current.setBounds(bbox);
  }, [bbox, apiRef]);

  useEffect(() => {
    if (Blank.is(googPlace)) return;
    cmd.dropPinAndPanTo(googPlace);
    cmd.openLocationPanelOnLargeScreens();
    const address = googPlace.formatted_address;
    cmd.set(['searchAddressInput'], address);
  }, [googPlace && googPlace.formatted_address]);
}
